import { QuoteListItem } from '../../components/QuoteListItem'

export const QuoteWebhookProcessingFailedListItem = (props: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => (
  <QuoteListItem
    {...props}
    description="Failed to process a Dropbox Sign webhook"
  />
)
